import { render, staticRenderFns } from "./pureProfitRateManage.vue?vue&type=template&id=6597eb10&scoped=true&"
import script from "./pureProfitRateManage.vue?vue&type=script&lang=js&"
export * from "./pureProfitRateManage.vue?vue&type=script&lang=js&"
import style0 from "./pureProfitRateManage.vue?vue&type=style&index=0&id=6597eb10&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6597eb10",
  null
  
)

export default component.exports